<div class="ht" *ngIf="loading.value">
    <div class="main-cnt">
        <div class="center-content vertical-middle heigt-100">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</div>
<div id="ht" *ngIf="!loading.value">
    <div id="main-cnt">

        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <ion-menu-button></ion-menu-button>
                    <span class="breadcrumb"><!--RUOLO a {{ pageTitle }}--></span>
                </ion-buttons>
                <div slot="end" class="notification-div">
                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                        <img [src]="sessionService?.user?.profileImg|s3Link">

                    </ion-avatar>
                    <button class="notification-button">
                        <ion-icon (click)="showModal($event)" color="light" size="large"
                                  name="notifications-circle-outline">

                        </ion-icon>
                        <ion-badge class="notifications-badge" color="success" >{{number}}</ion-badge>

                    </button>


                </div>
            </ion-toolbar>
            <br>

            <!-- edit da qui... -->
            <img class="main-logo svg-white" src="./assets/imgs/logo-blu.svg">
            <!-- ...a qui -->
        </ion-header>


        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">
                        <!-- edit da qui... -->


                        <!-- <div class="glass-blurred-background menu-box center-content">
                            <img class="block-image" src="./assets/imgs/squadre.svg">
                            <h2 class="text-center">MIA <br> <div class="wrap-text">SQUADRA</div></h2>
                        </div>
                        <div class="glass-blurred-background menu-box center-content">
                            <img class="block-image" src="./assets/imgs/clienti.svg">
                            <h2 class="text-center">MIEI <br> <div class="wrap-text">CLIENTI</div></h2>
                        </div>
                        <div class="glass-blurred-background menu-box center-content">
                            <img class="block-image" src="./assets/imgs/investimenti.svg">
                            <h2 class="text-center">MIO <br> <div class="wrap-text">INVESTIMENTO</div></h2>
                        </div>
                        <div class="glass-blurred-background menu-box center-content">
                            <img class="block-image" src="./assets/imgs/bonus.svg">
                            <h2 class="text-center">MIEI <br> <div class="wrap-text">BONUS</div></h2>
                        </div>-->

                        <app-client-home-menu
                                *ngIf="sessionService.user?.permessions == permessionsType.CLIENT"></app-client-home-menu>
                        <app-administrator-home-menu
                                *ngIf="sessionService.user?.permessions == permessionsType.ADMINISTRATOR"></app-administrator-home-menu>
                        <app-agent-home-menu
                                *ngIf="sessionService.user?.permessions != permessionsType.CLIENT && sessionService.user?.permessions != permessionsType.ADMINISTRATOR"></app-agent-home-menu>


                        <!-- ...a qui -->
                    </div>
                </div>
            </div>
        </ion-content>

    </div>
</div>


<!-- <ion-header>
    <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
            <ion-menu-button></ion-menu-button>
            <span class="breadcrumb">RUOLO a {{ pageTitle }}</span>
        </ion-buttons>
        <div class="notification-div">
            <div class="menu-user-icon" (click)="openPage('/my-profile')">

            </div>
        </div>
    </ion-toolbar>
</ion-header> -->

<!-- <ion-content>
    <div>
        <div class="profile-card-div">
            <ion-card class="home-card">
                <div class="home-header">
                    <img src="./assets/imgs/Logo-new.png" class="whiteLogo slide-in"/>
                </div>
            </ion-card>
        </div>
        <div class="home-data-card">
            <div class="dashboard-area">

                <app-client-home-menu
                        *ngIf="sessionService.user?.permessions == permessionsType.CLIENT"></app-client-home-menu>
                <app-administrator-home-menu
                        *ngIf="sessionService.user?.permessions == permessionsType.ADMINISTRATOR"></app-administrator-home-menu>
                <app-agent-home-menu
                        *ngIf="sessionService.user?.permessions != permessionsType.CLIENT && sessionService.user?.permessions != permessionsType.ADMINISTRATOR"></app-agent-home-menu>

            </div>
        </div>
    </div>
</ion-content> -->
